module.exports = __webpack_public_path__ + "static/code-coding-computer-34676.a749dc56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/code-coding-computer-34676.jpg
// module id = 457
// module chunks = 221374088121123